import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const strap = {
  id: 'strap',
  name: 'Strap',
  imgproxySettings,
  mobileImgproxySettings,
  options: {
    whitemintV: {
      pathTemplate: 'gs://sg360/251202/straps/s_whitemintV-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_whitemintV-{nnn}.png',
    },
    whitewhiteT: {
      pathTemplate: 'gs://sg360/251202/straps/s_whitewhiteT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_whitewhiteT-{nnn}.png',
    },
    blackblackT: {
      pathTemplate: 'gs://sg360/251202/straps/s_blackblackT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blackblackT-{nnn}.png',
    },
    greygreyT: {
      pathTemplate: 'gs://sg360/251202/straps/s_greygreyT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_greygreyT-{nnn}.png',
    },
    pinkpinkT: {
      pathTemplate: 'gs://sg360/251202/straps/s_pinkpinkT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_pinkpinkT-{nnn}.png',
    },
    sandsandT: {
      pathTemplate: 'gs://sg360/251202/straps/s_sandsandT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_sandsandT-{nnn}.png',
    },
    blackwhiteS: {
      pathTemplate: 'gs://sg360/251202/straps/s_blackwhiteT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blackwhiteT-{nnn}.png',
    },
    whiteblackS: {
      pathTemplate: 'gs://sg360/251202/straps/s_whiteblackT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_whiteblackT-{nnn}.png',
    },
    greyblackS: {
      pathTemplate: 'gs://sg360/251202/straps/s_greyblackT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_greyblackT-{nnn}.png',
    },
    whitepinkS: {
      pathTemplate: 'gs://sg360/251202/straps/s_whitepinkT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_whitepinkT-{nnn}.png',
    },
    blacktealS: {
      pathTemplate: 'gs://sg360/251202/straps/s_blacktealT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blacktealT-{nnn}.png',
    },
    sandblackS: {
      pathTemplate: 'gs://sg360/251202/straps/s_sandblackS-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_sandblackS-{nnn}.png',
    },
    whiteP: {
      pathTemplate: 'gs://sg360/251202/straps/s_whiteP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_whiteP-{nnn}.png',
    },
    blackP: {
      pathTemplate: 'gs://sg360/251202/straps/s_blackP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blackP-{nnn}.png',
    },
    blackLP: {
      pathTemplate: 'gs://sg360/251202/straps/s_blackLP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blackLP-{nnn}.png',
    },
    whiteLP: {
      pathTemplate: 'gs://sg360/251202/straps/s_whiteLP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_whiteLP-{nnn}.png',
    },
    tealLP: {
      pathTemplate: 'gs://sg360/251202/straps/s_tealLP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_tealLP-{nnn}.png',
    },
    greyLP: {
      pathTemplate: 'gs://sg360/251202/straps/s_greyLP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_greyLP-{nnn}.png',
    },
    beigeorangeV: {
      pathTemplate: 'gs://sg360/251202/straps/s_beigeorangeV-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_beigeorangeV-{nnn}.png',
    },
    beigebeigeS: {
      pathTemplate: 'gs://sg360/251202/straps/s_beigebeigeS-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_beigebeigeS-{nnn}.png',
    },
    navynavyS: {
      pathTemplate: 'gs://sg360/251202/straps/s_navynavyS-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_navynavyS-{nnn}.png',
    },
    woodsy: {
      pathTemplate: 'gs://sg360/251202/straps/s_woodsy-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_woodsy-{nnn}.png',
    },
    ari: {
      pathTemplate: 'gs://sg360/251202/straps/s_ari-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_ari-{nnn}.png',
    },
    katieo: {
      pathTemplate: 'gs://sg360/251202/straps/s_katieoSS-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_katieoSS-{nnn}.png',
    },
    rustblackS: {
      pathTemplate: 'gs://sg360/251202/straps/s_rustblackS-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_rustblackS-{nnn}.png',
    },
    rustrustT: {
      pathTemplate: 'gs://sg360/251202/straps/s_rustrustT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_rustrustT-{nnn}.png',
    },
    blushblushT: {
      pathTemplate: 'gs://sg360/251202/straps/s_blushblushT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blushblushT-{nnn}.png',
    },
    blushblackS: {
      pathTemplate: 'gs://sg360/251202/straps/s_blushblackS-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_blushblackS-{nnn}.png',
    },
    purple25: {
      pathTemplate: 'gs://sg360/251202/straps/s_purplehaze-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_purplehaze-{nnn}.png',
    },
    tealtealT: {
      pathTemplate: 'gs://sg360/251202/straps/s_tealtealT-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_tealtealT-{nnn}.png',
    },
    '1ftp25': {
      pathTemplate: 'gs://sg360/251202/straps/s_1ftp_25-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_1ftp_25-{nnn}.png',
    },
    pow23: {
      pathTemplate: 'gs://sg360/251202/straps/s_pow22-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251202/straps/s_pow22-{nnn}.png',
    },
    pow26: {
      pathTemplate: 'gs://sg360/260202/s_pow26-{nnn}.png',
      staticPathTemplate: 'gs://sg360/260202/s_pow26-{nnn}.png',
    },
    greybeigeW: {
      pathTemplate: 'gs://sg360/261019/s_beigegrey-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/s_beigegrey-{nnn}.png',
    },
    whiteblackD: {
      pathTemplate: 'gs://sg360/261019/s_community-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/s_community-{nnn}.png',
    },
    sagegreenS: {
      pathTemplate: 'gs://sg360/261019/s_sage-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/s_sage-{nnn}.png',
    },
    blackbrownLP: {
      pathTemplate: 'gs://sg360/261019/s_blackbrownLP-{nnn}.png',
      staticPathTemplate: 'gs://sg360/261019/s_blackbrownLP-{nnn}.png',
    },
    none: {
      pathTemplate: 'gs://sg360/251217/ghost/s_ghost-{nnn}.png',
      staticPathTemplate: 'gs://sg360/251217/ghost/s_ghost-{nnn}.png',
    },
  },
}

export default strap
